<div [formGroup]="form">
    <div class="form-group">
        <label for="street">{{ 'CORE.ADDRESS.STREET' | translate }}</label>
        <input type="text" class="form-control" id="street" placeholder="{{ 'CORE.ADDRESS.STREET' | translate }}" formControlName="street" />
    </div>
    <div class="row form-group">
        <div class="col-3">
            <label for="postalCode">{{ 'CORE.ADDRESS.ZIP' | translate }}</label>
            <input type="number" class="form-control" id="postalCode" placeholder="{{ 'CORE.ADDRESS.ZIP' | translate }}" formControlName="postalCode" />
        </div>
        <div class="col-9">
            <label for="city">{{ 'CORE.ADDRESS.CITY' | translate }}</label>
            <input type="text" class="form-control" id="city" placeholder="{{ 'CORE.ADDRESS.CITY' | translate }}" formControlName="city" />
        </div>
    </div>
    <div class="form-group">
        <label for="country">{{ 'CORE.ADDRESS.COUNTRY' | translate }}</label>
        <input type="text" class="form-control" id="country" placeholder="{{ 'CORE.ADDRESS.CITY' | translate }}" formControlName="country" />
    </div>
    <div class="horizontal-divider-dashed mt-2 mb-4"></div>
    <div class="form-group">
        <label for="phone">{{ 'CORE.ADDRESS.PHONE' | translate }}</label>
        <input type="text" class="form-control" id="phone" placeholder="{{ 'CORE.ADDRESS.PHONE' | translate }}" formControlName="phone" />
    </div>
    <div class="form-group">
        <label for="mobile">{{ 'CORE.ADDRESS.MOBILE' | translate }}</label>
        <input type="text" class="form-control" id="mobile" placeholder="{{ 'CORE.ADDRESS.MOBILE' | translate }}" formControlName="mobile" />
    </div>
</div>
